import Config from '@config';
import { initializeEmployeePositionsApi } from '@gasbi/shared/common/features/employeePositions';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  employeePositionApi,
  useGetEmployeePositionsQuery,
  useGetEmployeePositionByIdQuery,
  useCreateEmployeePositionMutation,
  useUpdateEmployeePositionMutation,
  useDeleteEmployeePositionByIdMutation,
  useGetEmployeePositionsIInfiniteQuery,
  useGetActivePositionsQuery,
} = initializeEmployeePositionsApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});
